import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import * as AssessmentActions from './assessment.actions';
import { AppService } from '../../app.service';
import { Assessment, AssessmentCategory, UserAssessment } from './assessment.models';
import { environment } from '../../../environments/environment';

@Injectable()
export class AssessmentEffects {
  loadAssessments$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AssessmentActions.loadAssessments),
      switchMap((action) => {
        return this.assessmentService
          .get('assessments', '', {
            appId: environment.appId,
            category_id: action.categoryId,
          })
          .then((assessments: Assessment[]) =>
            AssessmentActions.loadAssessmentsSuccess({ assessments })
          )
          .catch((error: any) =>
            AssessmentActions.loadAssessmentsFailure({
              error: error.response.data,
            })
          );
      })
    );
  });


  loadingUserAssessments$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AssessmentActions.loadUserAssessments),
      switchMap((action) => {
        return this.assessmentService.get('assessments', action.userId, {appId: environment.appId})
          .then((assessments: UserAssessment[]) => AssessmentActions.loadUserAssessmentsSuccess({assessments}))
          .catch((error) => AssessmentActions.loadUserAssessmentsFailure({error: error.message}))
      })
    );
  });

  loadingUserAssessment$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AssessmentActions.loadUserAssessment),
      switchMap((action) => {
        return this.assessmentService.get('assessments', `${action.userId}/${action.assessmentId}`, {appId: environment.appId})
          .then((assessment: UserAssessment) => AssessmentActions.loadUserAssessmentSuccess({assessment}))
          .catch((error) => AssessmentActions.loadUserAssessmentFailure({error: error.message}))
      })
    );
  });

  creatingUserAssessment$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AssessmentActions.createUserAssessment),
      switchMap((action) => {
        return this.assessmentService.post('assessments', action.userId, {appId: environment.appId}, {category_id: action.categoryId, assessment_id: action.assessmentId}, true)
          .then((assessment: UserAssessment) => {
            return AssessmentActions.createUserAssessmentSuccess({assessment});
          })
          .catch(error => AssessmentActions.createUserAssessmentFailure({error: error.message}))
      })
    );
  });

  submitAssessmentAnswer$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AssessmentActions.submitUserAssessmentQuestion),
      switchMap((action) => {
        const params = {
          assessment_id: action.assessmentId,
          question: action.question,
          answer: action.answer,
          action: action.action || ''
        }
        return this.assessmentService.put('assessments', action.userId, {appId: environment.appId}, params)
          .then((res) => AssessmentActions.submitUserAssessmentQuestionSuccess({assessment: res}))
          .catch((error) => AssessmentActions.submitUserAssessmentQuestionFailure({error: error.message}))
      })
    );
  });


  constructor(
    private actions$: Actions,
    private assessmentService: AppService<Assessment[]>
  ) {}
}
